/**
 * LocalNav
 * ページ内サブナビ（localNav）のアンカーを Lenis でスムーススクロール。
 * 全ページ共通。対象が無いページでは何もしない。
 */
export default class LocalNav {
  constructor() {
    const links = document.querySelectorAll('.localNav__link[href^="#"]');
    if (!links.length) return;

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const id = link.getAttribute('href');
        const target = id && id.length > 1 ? document.querySelector(id) : null;
        if (!target) return;
        e.preventDefault();
        if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
          window.__lenis.scrollTo(target, { offset: -72 });
        } else {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }
}
